export const EXSBWAREHOUSETYPE_SHOW_RESET = 'EXSBWAREHOUSETYPE_SHOW_RESET'
export const EXSBWAREHOUSETYPE_SHOW_SET_ERROR = 'EXSBWAREHOUSETYPE_SHOW_SET_ERROR'
export const EXSBWAREHOUSETYPE_SHOW_SET_RETRIEVED = 'EXSBWAREHOUSETYPE_SHOW_SET_RETRIEVED'
export const EXSBWAREHOUSETYPE_SHOW_TOGGLE_LOADING = 'EXSBWAREHOUSETYPE_SHOW_TOGGLE_LOADING'
